<template>
  <div class="homeFooter maxWidth">
    <div class="homeFooter-top">
      <img src="../assets/tubiaoFooter.png" alt="" />
    </div>
    <div class="homeFooter-main">
      <div class="homeFooter-mainTop">
        <img src="../assets/logo.png" alt="" />
      </div>
      <div class="homeFooter-mainMenu">
        <div
          class="mainMenuBox"
          v-for="(item, index) in homeFooterList.footer"
          :key="index"
        >
          <ul>
            <a v-if="item.name == '产品介绍'" href="javascript:void(0)"
              ><li>{{ item.name }}</li></a
            >
            <router-link :to="item.url" v-else
              ><li>{{ item.name }}</li></router-link
            >
            <router-link
              v-for="(itemText, indexText) in item.list"
              :key="indexText"
              :to="itemText.url"
            >
              <li>
                {{ itemText.name }}
              </li></router-link
            >
          </ul>
        </div>
        <div class="mainMenuBox">
          <ul>
            <li>{{ homeFooterList.company }}</li>
            <div class="boxText">
              <img src="../assets/youxiang.png" alt="" />
              <li>服务咨询：{{ homeFooterList.email }}</li>
            </div>
            <div class="boxText">
              <img src="../assets/weizhi.png" alt="" />
              <li>公司地址：{{ homeFooterList.address }}</li>
            </div>
            <div class="boxText">
              <img src="../assets/dianhua.png" alt="" />
              <li>电话咨询：{{ homeFooterList.tel }}</li>
            </div>
          </ul>
        </div>
        <div class="erweimaBox">
          <img src="../assets/bottomEWM.png" alt="" />
          <span>微信公众号</span>
        </div>
      </div>
    </div>
    <div class="homeFooter-bottom">
      <div class="toTop" @click="toTopClick">
        <img src="../assets/toTop.png" alt="" />
      </div>

      <div class="homeFooter-bottomInner">
        <div class="">
          <span
            >Copyright◎2022河北星巢信息技术有限公司. All rights reserved.</span
          >
        </div>
        <div class="guohuibox">
          <a href="https://beian.miit.gov.cn/" target="_blank">
            {{ wz ? "冀ICP备2021024834号-2" : "冀ICP备2021024834号-1" }}
          </a>
          <a
            target="_blank"
            :href="
              wz
                ? 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13030202003456'
                : 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13030202003455'
            "
          >
            <img src="../assets/guohui.png" alt="" />
            <span>
              {{
                wz
                  ? "冀公网安备 13030202003456号"
                  : "冀公网安备 13030202003455号"
              }}
            </span></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "homeFooter",
  data() {
    return {
      homeFooterList: {},
      wz: true
    };
  },
  created() {
    this.getList();
    var wz = document.domain;
    this.wz = /hbxingchao/.test(wz);
    console.log(document.domain);
  },
  methods: {
    getList() {
      this.$axios.get("index/common/getfooter").then(res => {
        console.log(res);
        if (res.status == 200) {
          this.homeFooterList = res.data.data;
        }
      });
    },
    toTopClick() {
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style scoped>
.maxWidth {
  max-width: 100%;
}
.homeFooter {
  width: 1920px;
  margin: 0 auto;
}
.homeFooter-top {
  padding-top: 5px;
  padding-left: 103px;
  margin-bottom: 24px;
}
.homeFooter-top img {
  display: block;
  width: 136px;
  height: 66px;
}
.homeFooter-main {
  width: 1280px;
  margin: 0 auto;
  margin-bottom: 90px;
}
.homeFooter-mainTop {
  margin-bottom: 52px;
}
.homeFooter-mainMenu {
  display: flex;
}
.mainMenuBox {
  margin-right: 68px;
}
.mainMenuBox:last-child {
  margin-right: 47px;
}
.mainMenuBox ul li {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  line-height: 38px;
  white-space: nowrap;
  cursor: pointer;
}

.mainMenuBox ul a:first-child li {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #454647;
  line-height: 38px;
  margin-bottom: 10px;
}
.boxText {
  display: flex;
  align-items: center;
}
.boxText img {
  display: block;
  width: 18px;
  height: 18px;
  margin-right: 11px;
}
.erweimaBox {
  display: flex;
  flex-direction: column;
  text-align: center;
}
.erweimaBox img {
  display: block;
  width: 171px;
  height: 171px;
  margin-bottom: 26px;
}
.erweimaBox span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
}
.homeFooter-bottom {
  border-top: 1px solid #d6dbdd;
  height: 77px;
  position: relative;
}
.homeFooter-bottomInner {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.homeFooter-bottomInner span {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  line-height: 77px;
}
.homeFooter-bottomInner a {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  line-height: 77px;
}
.toTop {
  width: 50px;
  height: 50px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  border: 1px solid #ffffff;
  border-radius: 25px;
  position: absolute;
  top: -25px;
  left: 50%;
  margin-left: -25px;
  cursor: pointer;
}
.toTop img {
  display: block;
  width: 22px;
  height: 22px;
  position: absolute;
  top: 50%;
  margin-top: -11px;
  left: 50%;
  margin-left: -11px;
}
.guohuibox {
  display: flex;
  align-items: center;
}
.guohuibox a {
  display: flex;
  align-items: center;
}
.guohuibox a img {
  display: block;
  width: 20px;
  height: 20px;
  margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeFooter.vue